import {
  OrderIntakeOption,
  OrderRequest,
  OrderRequestGroupErrorResponse,
  OrderRequestGroupResponse,
  OrderRequestGroupSuccessResponse
} from '../../declarations/types'
import {mapOrderRequestToV2Payload} from '../../Options/orderRequestMapper'

interface SubmitOrdersParams {
  updatedDeliveries: OrderRequest[]
  shouldUseV2: boolean
  selectedSite: OrderIntakeOption
  userProfileCountry: string | undefined
  businessLineCode: string
  userPrimaryOrganisationalUnit?: string
  mutateAsyncV1: (params: any) => Promise<any>
  mutateAsyncV2: (params: any) => Promise<any>
  isConfigurableSlots: boolean
  isAutoConfirmed: boolean
  setOrderSummaryDataArray: (dataArray: OrderRequestGroupResponse[]) => void
  setOrderSummary: (summary: any) => void
  setPlaceOrderStatus: (status: boolean) => void
  setShowConfirmationStatusScreen: (show: boolean) => void
}

export function submitOrders({
  updatedDeliveries,
  shouldUseV2,
  selectedSite,
  userProfileCountry,
  businessLineCode,
  userPrimaryOrganisationalUnit,
  mutateAsyncV2,
  mutateAsyncV1,
  isConfigurableSlots,
  isAutoConfirmed,
  setOrderSummary,
  setOrderSummaryDataArray,
  setPlaceOrderStatus,
  setShowConfirmationStatusScreen
}: SubmitOrdersParams): void {
  const finalMutateAsync = (delivery: OrderRequest) => {
    if (shouldUseV2) {
      const materialOptions = selectedSite.materials[delivery.payload.materialEnteredNumber]
      const materialOption = materialOptions?.[0]

      const payload = mapOrderRequestToV2Payload({
        order: delivery,
        country: userProfileCountry ?? selectedSite.shippingAddress.country ?? '',
        businessLine: businessLineCode,
        siteId:
          selectedSite.shippingAddress.siteId ?? selectedSite.shippingAddress.siteNumber ?? '',
        orgUnitId: materialOption?.material.orgUnitId ?? userPrimaryOrganisationalUnit ?? '',
        customerId: materialOption?.customerId ?? delivery.payload.customerId
      })

      return mutateAsyncV2({orderIntakePayload: payload})
    } else {
      return mutateAsyncV1({
        orderIntakePayload: delivery.payload,
        isConfigurableSlots,
        isAutoConfirmed
      })
    }
  }

  Promise.all(
    updatedDeliveries.map((delivery, index) => {
      return finalMutateAsync(delivery)
        .then((data) => {
          return {
            index,
            result: data,
            isSuccess: true,
            delivery
          } as OrderRequestGroupSuccessResponse
        })
        .catch((error) => {
          return {
            index,
            result: error,
            isSuccess: false,
            delivery
          } as OrderRequestGroupErrorResponse
        })
    })
  )
    .then((dataArray) => {
      setOrderSummaryDataArray(dataArray)

      const successfulResults = dataArray.filter(
        (data) => data.isSuccess
      ) as OrderRequestGroupSuccessResponse[]

      successfulResults.forEach((data) => {
        setOrderSummary(data.result)
      })

      setPlaceOrderStatus(false)
      setShowConfirmationStatusScreen(true)
    })
    .catch((error) => {
      const dataArray: OrderRequestGroupResponse[] = updatedDeliveries.map((delivery, index) => {
        return {
          index,
          result: error,
          isSuccess: false,
          delivery
        } as OrderRequestGroupErrorResponse
      })

      setOrderSummaryDataArray(dataArray)
      setPlaceOrderStatus(false)
      setShowConfirmationStatusScreen(true)
    })
}
